import React from "react";
import { component_tool } from "@/tool";
import RoleGroupAddList from "./roleGroupAdd/roleGroupAddList";
let { WizModal } = component_tool;

//配置项
const componentName = "roleGroup";
let ref;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "用户组名称",
    name: "groupName",
    dataIndex: "groupName",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "用户组编码",
    name: "groupCode",
    dataIndex: "groupCode",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "用户组状态",
    name: "state",
    dataIndex: "state",
    searchItem: {type: "select"},
    tableItem: {},
    dict: [
      { code: "ENABLE", codeName: "激活" },
      { code: "PROHIBIT", codeName: "禁用" }
    ]
  }
];

const templateConfig = (data)=>{
  const {roleId} = data;
  return {
    mainProps: {},
    content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort:['addUserGroup',"delete"],
        buttons: [
          {
            key: "addUserGroup",
            custom: true,
            params: { children: "添加用户组", type: "info" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "添加用户组",
                  diy: (e) => (
                    <RoleGroupAddList
                      {...e} roleId={roleId} key={new Date()}
                      ref={r => {
                        ref = r && r.getWrappedInstance();
                      }}
                    />
                  ),
                  onOk: () => {
                    ref._ok(data);
                  },
                  style:{ top: 20 },
                  width: 1000
                }
              }
            }
          }
          // ,
          // {
          //   key: "delete",
          //   custom: true,
          //   needSelect: true,
          //   params: { children: "删除", type:'danger' },
          //   customOnClick: {
          //     key: "action",
          //     params: {
          //       apiKey: "delete",
          //       apiParams: {}
          //     },
          //     formatParams: (rows, record, filters, callback) => {
          //       let ids = [];
          //       rows.forEach(row => {
          //         ids.push(row.id);
          //       });
          //       const content = "您确定要删除吗?";
          //       WizModal.confirm({
          //         title: "注意",
          //         content,
          //         onOk: () => {
          //           callback &&
          //             callback({
          //               ids: ids,
          //               ...filters
          //             });
          //         },
          //         onCancel() {}
          //       });
          //       return null;
          //     }
          //   }
          // }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      commonOperate: {
        //   add: true,
        //   delete: true
      }
    }
  }
  }
};



let reduxTemplateCofig = args => {
  const {roleId} = args;
  const apis = {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {roleId:roleId}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    }
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    keepInitApiParams:true,
    ...args
  };
};

export { reduxTemplateCofig, templateConfig };
